import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import {
  faStopwatch,
  faPlus,
  faMinus,
} from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
const Accordion = ({
  title,
  children,
  // progress,
  id,
  // isEnrolled,
  // duration,
  // handleMskillEnroll,
  // handleExploreClick,
  expertStatus,
}) => {
  const [isActive, setIsActive] = useState(false);

  const user_id = useSelector((store) => store?.profileDetails?.id);

  useEffect(() => {
    if (id === 0 || id === 1 || id === 2) {
      setIsActive(true);
    }
  }, [id]);

  const handleAccordionChange = () => {
    setIsActive(!isActive);
  };
  return (
    <div className="w-full">
      <div
        className={` flex w-full cursor-pointer items-center justify-between  rounded border-2 bg-[#FBFBFB] p-2 font-bold shadow-lg md:flex-row 
        
           ${isActive ? 'border-[#F39507]' : ''
          } transition-all duration-200 ease-in-out hover:shadow-xl`}
        onClick={handleAccordionChange}
      >
        <div className="z-100 flex w-full items-center justify-between text-left text-xs md:w-auto md:text-base ">
          <div className={`block w-auto ${isActive ? 'text-[#F39507]' : ''}`}>
            {title}
          </div>
        </div>
        <div className="relative ml-1 flex  w-full items-center justify-end md:w-auto md:justify-center">
          {title === 'About the Task' && (
            <div className={`block text-xs font-medium italic ${(expertStatus == 'Incomplete' || expertStatus == "Review pending" || expertStatus == "pending") ? 'text-red-500' : 'text-[#1E9B6E]'}`}>
              {expertStatus}
            </div>
          )}
          <button className="ml-4 cursor-pointer text-center">
            <FontAwesomeIcon
              icon={isActive ? faMinus : faPlus}
              className={`${isActive ? 'text-[#F1870A]' : ''}`}
            />
          </button>
        </div>
      </div>
      {isActive && (
        <div className=" border-x-2 py-1 shadow-lg md:py-2">{children}</div>
      )}
    </div>
  );
};

export default Accordion;
